import { useState, useEffect } from "react";
import { MileageMenuResponse } from "../../../../../../../../api/pub-product";
import { MileagePageWrapper } from "../../../../style";
import { MileageBuyListBody, MileageBuyListWrapper } from "../../style";

interface MenuData {
  pubId: number;
  name: string;
  price: number;
  id: number;
  count: number;
}

interface MileageBuyListProps {
  selectMenus: MileageMenuResponse[];
  setSelectMenus: (value: MileageMenuResponse[]) => void;
}
const MileageBuyList = ({
  selectMenus,
  setSelectMenus,
}: MileageBuyListProps) => {
  const size = 3;
  const [allList, setAllList] = useState<MenuData[]>([]);
  const [list, setList] = useState<MenuData[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [totalPay, setTotalPay] = useState(1);

  useEffect(() => {
    const total = selectMenus.reduce((acc, item) => acc + item.price, 0);
    setTotalPay(total);

    const groupedData: MenuData[] = [];

    selectMenus.forEach((item) => {
      const newItem = groupedData.find((data) => data.id === item.id);
      if (newItem) {
        newItem.count = newItem.count + 1;
      } else {
        groupedData.push({ ...item, count: 1 });
      }
    });
    setAllList(groupedData);
    setList(groupedData.slice((currentPage - 1) * size, currentPage * size));
    setTotalPage(Math.max(1, Math.ceil(groupedData.length / size)));
  }, [selectMenus, currentPage]);

  const onPageChange = async (nextPage: number) => {
    if (currentPage + nextPage <= 0) return;
    if (currentPage + nextPage > totalPage) return;
    setCurrentPage(currentPage + nextPage);
  };

  const handleDelete = (id: number) => {
    const data = [...selectMenus];
    const newData = data.filter((item) => item.id !== id);
    setSelectMenus(newData);
    if ((allList.length - 1) % size === 0 && currentPage === totalPage) {
      if (currentPage - 1 === 0) return;
      setCurrentPage(currentPage - 1);
    }
  };
  return (
    <MileageBuyListWrapper>
      <div className="header">
        <div className="item">주류</div>
        <div className="item">수량</div>
        <div className="item">가격</div>
      </div>
      <MileageBuyListBody>
        {list.map((item, index) => (
          <div className="item-wrapper" key={index}>
            <div className="item">{item.name}</div>
            <div className="item">{item.count}</div>
            <div className="item price">
              {(item.price * item.count).toLocaleString()}M
              <img
                src="image-web/solution/buy-delete.svg"
                alt="삭제"
                onClick={() => handleDelete(item.id)}
              />
            </div>
          </div>
        ))}
      </MileageBuyListBody>
      <MileagePageWrapper>
        <img
          src="image-web/solution/page-left.png"
          alt="arrow"
          onClick={() => onPageChange(-1)}
        />
        <div className="page">
          {currentPage} / {totalPage}
        </div>
        <img
          src="image-web/solution/page-right.png"
          alt="arrow"
          onClick={() => onPageChange(1)}
        />
      </MileagePageWrapper>
      <div className="total">
        TOTAL <span>{totalPay.toLocaleString()} M</span>
      </div>
    </MileageBuyListWrapper>
  );
};
export default MileageBuyList;
